import { Component, Input, computed, signal } from '@angular/core';
import { SpacerWidget, Theme, WidgetColors } from '../../models/reader-document';
import { resolveWidgetStyleColors } from '../../utils/widget-style.utils';

@Component({
  selector: 'wr-spacer-widget',
  standalone: true,
  template: `
    <div
      [style.height.px]="height()"
      [style.background]="background()"
      [style.padding-top.px]="paddingTop()"
      [style.padding-bottom.px]="paddingBottom()"
    ></div>
  `,
})
export class SpacerWidgetComponent {
  private widgetSig = signal<SpacerWidget | null>(null);
  private themeSig = signal<Theme & { isDark?: boolean } | null>(null);

  @Input() set json(value: SpacerWidget) {
    this.widgetSig.set(value);
  }

  @Input() set theme(value: Theme | undefined) {
    this.themeSig.set(value ?? null);
  }

  widget = computed(() => this.widgetSig());
  background = computed(() => {
    const w = this.widget();
    const theme = this.themeSig();
    const isDark = theme?.isDark ?? false;

    const widgetColors = resolveWidgetStyleColors(w?.widgetStyle, isDark);

    if (widgetColors?.background) return widgetColors.background;

    const themeColors: WidgetColors | undefined = (isDark
      ? theme?.darkColors
      : theme?.lightColors) as WidgetColors | undefined;

    if (themeColors?.background) return themeColors.background;

    return 'transparent';
  });

  paddingTop = computed(() => this.widget()?.widgetStyle?.padding?.top ?? 0);
  paddingBottom = computed(() => this.widget()?.widgetStyle?.padding?.bottom ?? 0);

  height = computed(() => {
    const spacing = this.widget()?.spacing ?? 0;
    return spacing + this.paddingTop() + this.paddingBottom();
  });
}
